<!--P095、P099、P100、P101-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">商户维护</div>
    </div>
    <!--查询栏-->
    <div class="cs_margin_top div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">商户</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search width_280" placeholder="请输入">
      <button class="ui_btn_search_yellow btn_search" type="button" @click="btnSearch">查询</button>
    </div>
    <!--表格-->
    <div class="cs_margin_top_sm div_search_result cs_padding_top_lg">
      <div class="div_operation_table">
        <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">添加商户
        </button>
        <button v-show="isStop && isStopShow" @click="btnStart" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">启用
        </button>
        <button v-show="!isStop && isStopShow" @click="btnStop" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">停用
        </button>
      </div>
      <div class="cs_margin_top div_table">
        <table class="cs_table cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="320px">商户编号</th>
            <th width="480px">商户名称</th>
            <th width="241px">启用状态</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTr(item)">
            <td>{{index+1}}</td>
            <td><a @click.stop="$router.push({name:'MerchantDetail', query: {num:item.merchantNum}})">{{item.merchantNum}}</a></td>
            <td>{{item.merchantName}}</td>
            <td>{{KITCHEN_STATUS[item.isStop]}}</td>
          </tr>
          <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="div_page_download">
        <!--上一页-->
        <button v-show="search.pagination>1" @click="showList(search.pagination < 2?1:search.pagination-1)"
                class="btn_page_up" type="button">
        </button>
        <button v-show="search.pagination<=1" class="btn_page_up_disable" type="button"></button>
        <div class="current_page">{{search.pagination}}</div>
        <div class="oblique_line">/</div>
        <div class="total_page">{{search.totalPage}}</div>
        <!--下一页-->
        <button v-show="search.pagination!==search.totalPage" @click="showList(search.pagination+1)" class="btn_page_down" type="button"></button>
        <button v-show="search.pagination===search.totalPage" class="btn_page_down_disable" type="button"></button>
        <div @click="jump()" class="type_page_jump">跳转至</div>
        <input v-model="search.pageJump" class="txt_page_jump" type="text"
               @keyup="checkPositiveInt($event)" @blur="search.pageJump=checkPositiveInt($event)">
      </div>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import {Page, PAGE_SIZE,KITCHEN_STATUS} from "../../assets/utils/constants"
  import StorageConst from "../../assets/utils/StorageConst";
  export default {
    name: "MerchantManage",
    components: {},
    data: function () {
      return {
        isStopShow: false,
        isStop: false,
        search: {
          name: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.MERCHANT_MANAGE,"name", ""),
          pageJump: "",
          totalPage: "",
          pagination: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.MERCHANT_MANAGE,"pagination", 1)
        },
        orderList: [],
        selectedId: "",
        selectedName: "",
        PAGE_SIZE: PAGE_SIZE,
        KITCHEN_STATUS: KITCHEN_STATUS,
      }
    },
    created: function () {
      this.showList(this.search.pagination);
    },
    mounted: function() {
    },
    methods: {
      showList(pagination) {
        this.selectedId = "";
        this.selectedName = "";
        this.isStop = false;
        this.isStopShow = false;
        this.$ajax.merchant.pageByFuzzy.bind(this)(this.search.name, new Page(PAGE_SIZE, pagination), (data) => {
          //显示列表
          this.search.totalPage = data.data.totalPage;
          this.search.pagination = data.data.pagination;
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.orderList = list;
          this.setStoreItem(StorageConst.LOCAL_PAGE_LIST.MERCHANT_MANAGE, JSON.stringify(this.search));
        }, (data) => {
        }, true)
      },
      btnSearch(){
        this.showList(1);
      },
      jump() {
        if (!this.isEmpty(this.search.pageJump)) {
          if(this.search.pageJump>this.search.totalPage){
            this.showList(this.search.totalPage);
          }else {
            this.showList(this.search.pageJump);
          }
        }
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.id;
          this.selectedName = item.merchantName;
          this.isStop = item.isStop;
          this.isStopShow = true;
        }else {
          this.selectedId = "";
          this.selectedName = "";
          this.isStop = false;
          this.isStopShow = false;
        }
      },
      btnStop(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$alert("确认停用商户"+this.selectedName+"吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.merchant.stop.bind(this)(this.selectedId, true, (data) => {
              this.$toast("停用成功");
              this.showList(this.search.pagination);
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnStart(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$alert("确认启用商户"+this.selectedName+"吗？", (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.merchant.stop.bind(this)(this.selectedId, false, (data) => {
              this.$toast("启用成功");
              this.showList(this.search.pagination);
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnAdd(){
        this.$router.push({name:'MerchantAdd'});
      },
    },
  }
</script>

<style scoped>
.width_280{width: 280px;}
</style>



// WEBPACK FOOTER //
// src/page/merchant/MerchantManage.vue